import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import liff from "@line/liff";
import {
  Typography,
  Stack,
  Box,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";
//共通コンポーネント
import { bottomButton } from "../../common/styles";
import { Header, MainColorButton, Loading } from "../../components";
import { ERROR, CUSTOMER_RESULT, NAVIGATE_PAY } from "../../routes/path";
//決済処理API
import { postPaymentStart } from "../../server/axios";
import { getGmoMessageByErroRCode } from "../../utils/getGmoMsgUtil";
import { closeKeyboard } from "../../utils/closeKeyboard";

/**
 * PAY決済開始画面
 * @returns
 */
const StartPay = () => {
  const navigate = useNavigate();
  const location = useLocation();
  //Loadingコンポネント表示非表示state
  const [loadingOpen, setLoadingOpen] = useState(false);
  const [startProcess, setStartProcess] = useState(false);
  const [header, setHeader] = useState("");
  const [mailAddress, setMailAddress] = useState("");
  const emailReg =
    /^[a-zA-Z0-9.!#$&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  const emailCharReg = /^[a-zA-Z0-9@.!#$&'*+/=?^_`{|}~-]*$/;

  //エラーメッセージ表示
  const [openSnackbar, setOpenSnackbar] = useState({
    status: false,
    message: "",
  });
  const handleSnackbarClose = () => {
    setOpenSnackbar({
      status: false,
      message: "",
    });
  };

  useEffect(() => {
    if (!location.state) navigate(ERROR);
    setHeader(location.state.header);
  }, []);

  const setMedicalAccounting = () => {
    if (location.state.paymentMethodClass === "20") {
      let messageList = [];
      if (!mailAddress) {
        messageList.push("メールアドレスを入力してください。");
      } else if (!emailReg.test(mailAddress)) {
        messageList.push("メールアドレスは正しくありません。");
      }
      if (messageList.length > 0) {
        setOpenSnackbar({
          status: true,
          message: (
            <>
              {messageList.map((info, index) => (
                <div key={index} style={{ display: "inline" }}>
                  <br />
                  <strong>{info}</strong>
                </div>
              ))}
            </>
          ),
        });
        return;
      }
    }
    setLoadingOpen(true);
    setStartProcess(true);
    postPaymentStart({
      receptedNumber: location.state.receptedNumber,
      customerId: location.state.customerId,
      paymentMethodClass: location.state.paymentMethodClass,
      updateDatetime: location.state.updateDatetime,
      mailAddress: mailAddress,
    }).then((res) => {
      let errMsg = "";
      let errorCode = "E99";
      switch (res.data.result) {
        case 1:
          setLoadingOpen(false);
          if (location.state.paymentMethodClass === "20") {
            navigate(CUSTOMER_RESULT, {
              state: {
                header: header,
                message:
                  "ご入力されたメールアドレスに「決済依頼メール」が届きますので、メールの案内に従って支払い画面へ進んでください。",
              },
            });
          } else {
            nextPage(res.data.startUrl, res.data.accessId, res.data.token);
          }
          break;
        case -1: // -1 排他エラー
          setLoadingOpen(false);
          navigate(CUSTOMER_RESULT, {
            state: {
              header: "決済エラー",
              message: "決済処理に失敗しました。もう一度お試しください。",
            },
          });
          break;
        case -3: // -3 処方箋取消済
          setLoadingOpen(false);
          navigate(CUSTOMER_RESULT, {
            state: {
              header: "お会計",
              message: "選択されたお申し込みは、取消されています。",
            },
          });
          break;
        default: // -2 システム定数エラー, -4 オーダーID桁数不正,取引登録/決済実行エラー
          const response = res.data.message;
          const regex = /ErrInfo=([^|&]*)/;
          const match = response.match(regex);
          errorCode = match ? match[1] : "E99";
          errMsg = getGmoMessageByErroRCode(errorCode);
          setLoadingOpen(false);
          navigate(CUSTOMER_RESULT, {
            state: {
              header: "決済エラー",
              message: `${errorCode}：\n${errMsg}`,
            },
          });
          break;
      }
    });
  };

  const nextPage = (startUrl, accessId, token) => {
    if (liff.isInClient()) {
      const url = window.location.href.replace(
        window.location.pathname,
        NAVIGATE_PAY
      );
      const navigateUrl = new URL(url);
      navigateUrl.searchParams.set("startUrl", startUrl);
      navigateUrl.searchParams.set("accessId", accessId);
      navigateUrl.searchParams.set("token", token);
      liff.openWindow({
        url: navigateUrl.toString(),
        external: true,
      });
    } else {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = startUrl;
      const inputAccessId = document.createElement("input");
      inputAccessId.type = "hidden";
      inputAccessId.name = "AccessID";
      inputAccessId.value = accessId;
      const inputToken = document.createElement("input");
      inputToken.type = "hidden";
      inputToken.name = "Token";
      inputToken.value = token;
      form.appendChild(inputAccessId);
      form.appendChild(inputToken);
      form.style.display = "none";
      document.body.appendChild(form);
      form.submit();
    }
  };

  return (
    <>
      <Loading open={loadingOpen} />
      <Header title={header} />
      <Snackbar
        open={openSnackbar.status}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleSnackbarClose}
        sx={{ mt: "8vh" }}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          onClose={handleSnackbarClose}
        >
          {openSnackbar.message}
        </Alert>
      </Snackbar>
      {location.state.paymentMethodClass === "20" ? (
        <Stack
          height="76vh"
          marginTop="9vh"
          width="95%"
          marginLeft="auto"
          marginRight="auto"
          spacing="8%"
        >
          <Typography align="left">
            モバイルSuicaのサービス登録をしているメールアドレスを入力してください。
            <br />
            ※「@mobilesuica.com」のメールを受け取れるようにしてください。
          </Typography>

          <Box sx={{ width: "100%" }}>
            <Box sx={{ marginLeft: "8%" }}>
              <Typography>メールアドレス</Typography>
              <Box sx={{ marginTop: "1vh" }}>
                <TextField
                  hiddenLabel
                  fullWidth
                  size="small"
                  value={mailAddress}
                  type="email"
                  inputProps={{ required: true }}
                  onChange={(e) => {
                    if (emailCharReg.test(e.target.value)) {
                      setMailAddress(e.target.value);
                    }
                  }}
                  onKeyDown={(event) => closeKeyboard(event)}
                ></TextField>
              </Box>
            </Box>
          </Box>
        </Stack>
      ) : (
        <Stack
          height="76vh"
          marginTop="9vh"
          width="95%"
          marginLeft="auto"
          marginRight="auto"
          spacing={2}
        >
          <Typography sx={{ fontSize: "110%" }} align="left">
            この後、選択いただいた決済方法のアプリ／ブラウザが起動します。
            <br />
            支払完了までアプリ／ブラウザ画面を閉じないようお願いします。
          </Typography>
        </Stack>
      )}
      <MainColorButton
        label="決済"
        style={bottomButton}
        onClick={() => setMedicalAccounting()}
        disabled={startProcess}
      />
    </>
  );
};

export default StartPay;
